<template>
  <div class="d-flex justify-content-center">
    <div class="w-40 pt-10">
    <div>
        <div class="img-container d-flex align-items-center justify-content-center">
          <img
            :src="require(`@slg/web-customer-shared/src/assets/img/blocked-auth.svg`)"
            :alt="$t('imageAlt.deactivatedAccount')"
          >
        </div>
        <div class="tittle-container pt-6 text-center">
            <div
                v-for="(row, index) in getTextRows"
                :key="row"
                class="d-flex"
            >
                <span
                    :data-test="`messageToDeactivatedUser-${index}`"
                    class="body-2 textPrimary--text">
                    {{ row }}
                </span>
            </div>
        </div>
    </div>
    <div class="pt-5 d-flex justify-content-center">
        <VBtn
            data-test="contactUsButton"
            class="w-50 brandingPrimary--text header__link"
            color="brandingPrimary--text"
            :active="false"
            exact
            outlined
            :to="{ name: 'ContactUs' }"
        >
            <span class="button brandingPrimary--text">
            {{ $t('authForm.contactUs') }}
            </span>
        </VBtn>
    </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SDeactivatedUser',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '../../composables';

const { t } = useI18n();

const getTextRows = computed(() => [
  t('deactivatedUser.yourAccountHasBeenSuspended'),
  t('deactivatedUser.pleaseContactOurSupportTeamForAnyHelpYouNeed'),
]);
</script>
